import mapbox from "mapbox-gl";
import { getMapboxAccessToken } from "src/config/appConfig.ts";

mapbox.accessToken = getMapboxAccessToken();
